import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-side">
        <div>
          <div className="tag">Learn · Grow · Certify</div>
          <h1>Reset your<br />password.</h1>
          <p style={{ opacity: 0.8, fontSize: '1.1rem', maxWidth: 380 }}>
            No worries — enter your email and we'll send you a link to get back into your account.
          </p>
        </div>
        <ul>
          <li>→ Reset link expires in 10 minutes</li>
          <li>→ Sent straight to your inbox</li>
          <li>→ Back to learning in no time</li>
        </ul>
      </div>
      <div className="auth-form-wrap">
        <form className="auth-form" onSubmit={handleSubmit}>
          <h2>Forgot password?</h2>
          <p className="subtitle">Enter your email and we'll send you a reset link.</p>

          {sent ? (
            <div className="card" style={{ background: 'var(--bg)', padding: '1.25rem' }}>
              <strong>Check your inbox</strong>
              <p className="text-muted" style={{ marginTop: '0.5rem' }}>
                A password reset link has been sent to <strong>{email}</strong>. It expires in 10 minutes.
              </p>
            </div>
          ) : (
            <>
              <div className="form-group">
                <label>Email</label>
                <input
                  className="input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="you@example.com"
                />
              </div>

              <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
                {loading ? <span className="spinner"></span> : 'Send reset link →'}
              </button>
            </>
          )}

          <p className="text-center mt-3 text-muted">
            Remembered your password? <Link to="/login">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
